import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsProtonmailComponent } from './simple-icons-protonmail.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsProtonmailComponent ],
    exports:      [ SimpleIconsProtonmailComponent ],
    bootstrap:    []
})
export class SimpleIconsProtonmailModule {}
